import * as React from "react"

const Globe = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 14c1.4 0 2.6-2.7 2.6-6S9.4 2 8 2m0 12c-1.4 0-2.6-2.7-2.6-6S6.6 2 8 2m0 12a6 6 0 0 0 6-6m-6 6a6 6 0 0 1-6-6m6-6a6 6 0 0 0-6 6m6-6a6 6 0 0 1 6 6M2 8h12"
    />
  </svg>
)

export default Globe
